"use strict";

exports.__esModule = true;
var _exportNames = {
  callIfFunc: true,
  cloneWithStyles: true,
  stylePropType: true,
  mapIndexed: true,
  makeMediaQuery: true,
  fontPropType: true,
  themePropType: true,
  normalizeArray: true
};
exports.themePropType = exports.stylePropType = exports.normalizeArray = exports.mapIndexed = exports.makeMediaQuery = exports.fontPropType = exports.cloneWithStyles = exports.callIfFunc = void 0;

var _hooks = require("./hooks");

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hooks[key]) return;
  exports[key] = _hooks[key];
});

var _formUtils = require("./form-utils");

Object.keys(_formUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formUtils[key]) return;
  exports[key] = _formUtils[key];
});

var _truncate = require("./truncate");

Object.keys(_truncate).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _truncate[key]) return;
  exports[key] = _truncate[key];
});

var _callIfFunc = _interopRequireDefault(require("./call-if-func"));

exports.callIfFunc = _callIfFunc["default"];

var _cloneWithStyles = _interopRequireDefault(require("./clone-with-styles"));

exports.cloneWithStyles = _cloneWithStyles["default"];

var _stylePropType = _interopRequireDefault(require("./style-prop-type"));

exports.stylePropType = _stylePropType["default"];

var _mapIndexed = _interopRequireDefault(require("./map-indexed"));

exports.mapIndexed = _mapIndexed["default"];

var _mediaQuery = _interopRequireDefault(require("./media-query"));

exports.makeMediaQuery = _mediaQuery["default"];

var _fontPropType = _interopRequireDefault(require("./font-prop-type"));

exports.fontPropType = _fontPropType["default"];

var _themePropType = _interopRequireDefault(require("./theme-prop-type"));

exports.themePropType = _themePropType["default"];

var _normalizeArray = _interopRequireDefault(require("./normalizeArray"));

exports.normalizeArray = _normalizeArray["default"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }